/* ak-eggs.js — F4 extra easter eggs (storefront). The original three (logo x7, Konami, footer dot) stay in anamkara.js.
   - type "soulfriends" anywhere -> white flash -> archive, straight to the drop details
   - triple-click the huge type strip -> toast -> archive drop details
   - type "anam" -> the header logo glitches for a moment
   - 404 page dot -> archive */
(function () {
  'use strict';
  var toast = document.getElementById('unlock-toast');
  function say(t) { if (!toast) return; toast.textContent = t; toast.classList.add('show'); setTimeout(function () { toast.classList.remove('show'); }, 2200); }
  function go() { window.location.href = '/pages/art#next'; }
  function flash(cb) {
    var f = document.createElement('div'); f.className = 'egg-flash'; document.body.appendChild(f);
    setTimeout(cb, 650);
  }

  var buf = '';
  window.addEventListener('keydown', function (e) {
    var t = e.target && e.target.tagName; if (t === 'INPUT' || t === 'TEXTAREA' || t === 'SELECT') return;
    if (e.metaKey || e.ctrlKey || e.altKey || !e.key || e.key.length !== 1) return;
    buf = (buf + e.key.toLowerCase()).slice(-12);
    if (buf.slice(-11) === 'soulfriends') { buf = ''; say('[SOUL FRIENDS]'); flash(go); }
    else if (buf.slice(-4) === 'anam') {
      var l = document.querySelector('.site-logo'); if (l) { l.classList.add('egg-glitch'); setTimeout(function () { l.classList.remove('egg-glitch'); }, 900); }
    }
  });

  document.querySelectorAll('[data-strip]').forEach(function (s) {
    var n = 0, tm;
    s.style.cursor = 'default';
    s.addEventListener('click', function () {
      n++; clearTimeout(tm); tm = setTimeout(function () { n = 0; }, 600);
      if (n >= 3) { n = 0; say('[NEXT]'); flash(go); }
    });
  });

  var dot = document.getElementById('egg-404');
  if (dot) dot.addEventListener('click', function (e) { e.preventDefault(); say('[UNLOCKED]'); flash(go); });
})();

/* cart count bump when the number changes */
(function () {
  if (!window.MutationObserver) return;
  document.querySelectorAll('.cart-count').forEach(function (el) {
    new MutationObserver(function () { el.style.transform = 'scale(1.6)'; setTimeout(function () { el.style.transform = ''; }, 260); }).observe(el, { childList: true, characterData: true, subtree: true });
  });
})();
